<template>
  <v-dialog v-model="dialog" width="550">
    <template v-if="showBtn" v-slot:activator="{}">
      <p
        v-if="chip && employee && employee.user.work_role"
        @click.stop.prevent="
          $userCheckAccess({
            abilities: ['edit_hr', 'view_work_roles'],
          })
            ? create
              ? openModalCreate()
              : openModalEdit()
            : undefined
        "
        class="chip f12 fw500"
        :class="{
          active: employee.user.work_role,
          disabled: !$userCheckAccess({
            abilities: ['edit_hr', 'view_work_roles'],
          }),
        }"
      >
        {{
          employee.user.work_role
            ? employee.user.work_role.name
            : localStorage.translations.pages.personnel_department.employees_card['dolzhnost-ne-naznachena']
        }}
      </p>
      <BaseButton
        v-else-if="employee === null || employee === undefined"
        @click="create ? openModalCreate() : openModalEdit()"
        :text="
          localStorage.translations.pages.personnel_department
            .dialog_employeepositionappointment_buttons['naznachit-dolzhnost']
        "
      >
        <template v-slot:icon>
          <svg
            width="17"
            height="18"
            viewBox="0 0 17 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.81345 6.74384C6.74986 6.74384 7.56072 6.41155 8.22325 5.75594C8.88577 5.10044 9.22162 4.2984 9.22162 3.37181C9.22162 2.44555 8.88577 1.6434 8.22314 0.987682C7.5605 0.332289 6.74975 0 5.81345 0C4.87693 0 4.06629 0.332289 3.40376 0.987789C2.74123 1.64329 2.40527 2.44544 2.40527 3.37181C2.40527 4.2984 2.74123 5.10055 3.40387 5.75605C4.0665 6.41144 4.87725 6.74384 5.81345 6.74384Z"
              fill="#F2F2F2"
            />
            <path
              d="M10 14L12.25 17L16 11"
              stroke="#F2F2F2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M7.9357 14C7.93572 11.8886 9.58914 10.1593 11.6848 10.0104C11.6776 9.96747 11.6701 9.92419 11.6622 9.88059C11.6047 9.564 11.5308 9.26471 11.4423 8.99117C11.3508 8.70844 11.2265 8.42924 11.0727 8.16168C10.9132 7.88397 10.7258 7.64215 10.5155 7.44316C10.2956 7.23498 10.0263 7.06761 9.71497 6.94553C9.40471 6.82408 9.06087 6.76256 8.69306 6.76256C8.54861 6.76256 8.40892 6.8212 8.13914 6.99498C7.9731 7.10211 7.77889 7.22601 7.56211 7.36305C7.37675 7.4799 7.12565 7.58938 6.81549 7.6885C6.51289 7.78538 6.20564 7.83451 5.90239 7.83451C5.59915 7.83451 5.29201 7.78538 4.98909 7.6885C4.67925 7.58949 4.42814 7.48001 4.243 7.36316C4.02828 7.2274 3.83395 7.1035 3.66543 6.99487C3.39598 6.82109 3.25617 6.76245 3.11173 6.76245C2.74381 6.76245 2.40008 6.82408 2.08992 6.94563C1.77879 7.0675 1.50944 7.23488 1.28932 7.44326C1.07913 7.64236 0.89161 7.88407 0.732266 8.16168C0.578645 8.42924 0.454279 8.70834 0.362733 8.99128C0.274317 9.26482 0.200367 9.564 0.142934 9.88059C0.086041 10.1944 0.0473928 10.4921 0.0282845 10.7655C0.00950014 11.0334 0 11.3114 0 11.5922C0 12.323 0.234805 12.9147 0.697828 13.351C1.15513 13.7815 1.76022 14 2.49605 14H7.9357Z"
              fill="#F2F2F2"
            />
          </svg>
        </template>
      </BaseButton>
    </template>
    <transition :duration="150">
      <div class="edit">
        <CloseModalBtn :closeModal="closeModal" />
        <h5>
          {{
            create
              ? localStorage.translations.pages.personnel_department
                  .dialog_employeepositionappointment['naznachenie-dolzhnosti-sotrudnika']
              : localStorage.translations.pages.personnel_department
                  .dialog_employeepositionappointment['relink_employee_role']
          }}
        </h5>
        <v-form ref="form" lazy-validation v-model="valid" @submit.prevent="createOrUpdate" class="d-grid gap-5">
          <BaseInput
            type="autocomplete"
            :label="localStorage.translations.pages.personnel_department
                .dialog_employeepositionappointment_labels['sotrudnik']"
            prepend-inner-icon="search"
            :disabled="data.user_id ? true : false"
            :placeholder="
                  localStorage.translations.pages.personnel_department
                    .dialog_employeepositionappointment_inputs['ne-vybran']
                "
            v-model="user_id"
            :items="
                  data.user_id ? employeeAll : employeeAll.filter((i) => i.user.work_role === null)
                "
            :item-value="(i) => i.user.id"
            :item-text="(i) => i.user.first_name + ' ' + i.user.last_name"
            append-icon="fas fa-angle-down"
            :rules="['required']"
          />
          <BaseInput
            type="autocomplete"
            :label="localStorage.translations.pages.personnel_department
                .dialog_employeepositionappointment_labels['dolzhnost']"
            prepend-inner-icon="search"
            :placeholder="
                  localStorage.translations.pages.personnel_department
                    .dialog_employeepositionappointment_inputs['ne-vybran']
                "
            v-model="work_role_id"
            :items="
                  employeeRolesAll.filter(
                    (i) => i.type === 'role' && i.vacancies_count > i.users_count,
                  )
                "
            :item-value="(i) => i.id"
            :item-text="(i) => i.name"
            append-icon="fas fa-angle-down"
            :disabled="!user_id"
            :rules="['required']"
          />
          <div class="container_btn">
            <BaseButton
              type="submit"
              :text="
                localStorage.translations.pages.personnel_department
                  .dialog_employeepositionappointment_buttons['sohranit']
              "
              default_icon="button-save"
            />
          </div>
        </v-form>
      </div>
    </transition>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CloseModalBtn from 'components/CloseModalBtn'
import BaseInput from "components/base/BaseInput";

export default {
  name: 'EmployeeRolesLinkModal',
  components: {BaseInput, CloseModalBtn },
  props: {
    id: [String, Number],
    minimalize: Boolean,
    showBtn: {
      type: Boolean,
      default: true,
    },
    chip: Boolean,
    employee: Object,
  },
  data() {
    return {
      dialog: false,
      create: true,
      valid: true,
      user_id: null,
      work_role_id: null,
      data: {},
    }
  },
  computed: {
    ...mapGetters(['inputRules']),
    ...mapGetters('employeeRoles', ['employeeRolesAll', 'employeeRolesGrid']),
    ...mapGetters('employee', ['employeeAll']),
    apiDomain() {
      return this.$store.state.apiDomain
    },
  },
  watch: {
    dialog() {
      if (this.dialog) {
        this.onEmployeeRolesAll()
        this.onEmployeeAll()
        if (this.employee) {
          this.data.user_id = this.employee.user.id
          this.user_id = this.employee.user.id
          if (this.employee.user.work_role) {
            this.create = false
          } else {
            this.create = true
          }
        }
      }
    },
    employeeAll() {
      if (this.employeeAll && this.user_id) {
        let employeeSelect = this.employeeAll.find((i) => i.user.id === this.user_id)
        this.work_role_id = employeeSelect.user.work_role ? employeeSelect.user.work_role.id : null
      }
    },
  },
  methods: {
    ...mapActions('employeeRoles', ['onEmployeeRolesAll', 'onEmployeeRolesGrid']),
    ...mapActions('employee', ['onEmployeeAll', 'onEmployeeListGroupsAndWorkTypes']),
    ...mapActions('user', ['onUserUpdateWorkRole']),
    findEmployeeName(userId) {
      if (this.employeeAll.length) {
        let employee = this.employeeAll.find((i) => i.user.id == userId)
        return employee.user.first_name + ' ' + employee.user.last_name
      } else {
        return ''
      }
    },
    openModalCreate() {
      this.dialog = true
      this.create = true
    },
    openModalCreate_parentId(roleId) {
      this.dialog = true
      this.create = true
      if (roleId) {
        this.data.parentRoleId = roleId
      }
    },
    openModalEdit() {
      this.dialog = true
      this.create = false
    },
    openModalEdit_userId(user_id) {
      this.dialog = true
      this.create = false
      if (user_id) {
        this.user_id = user_id
        this.data.user_id = user_id
      }
    },
    closeModal() {
      this.dialog = false
      this.user_id = null
      this.work_role_id = null
      this.data = {}
    },
    validate() {
      this.$refs.form.validate()
    },
    downloadPageData() {
      let data = {
        limit: this.$route.query.limit,
        page: this.$route.query.page,
      }
      // if (this.filterParams.length) {
      //     data.filters = this.filterParams
      // }
      if (this.$route.query.sort_param && this.$route.query.sort_value) {
        data.sort = {
          param: this.$route.query.sort_param,
          value: this.$route.query.sort_value,
        }
      }
      if (this.$route.query.search) {
        data.search = this.$route.query.search
      }
      this.onEmployeeListGroupsAndWorkTypes(data)
    },
    async createOrUpdate() {
      await this.validate()
      if (this.valid === true) {
        let data = {
          user_id: this.user_id,
          work_role_id: this.data.parentRoleId ? this.data.parentRoleId : this.work_role_id,
        }
        this.onUserUpdateWorkRole(data)
          .then(() => {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message:
                  this.localStorage.translations.pages.common.notifications[
                    'izmeneniya-uspeshno-sohraneny'
                  ],
                IsError: false,
              },

              { root: true },
            )
            if (this.$route.name == 'employeesAll') {
              this.downloadPageData()
            } else {
              this.onEmployeeRolesGrid({
                limit: 100000,
                page: 1,
              })
            }
            this.closeModal()
          })
          .catch(() => {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message: this.localStorage.translations.pages.common.notifications['oshibka'],
                IsError: true,
              },
              { root: true },
            )
          })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.chip {
  margin-top: 20px;
  margin-bottom: 0px;
  background: #828282;
  border-radius: 9px;
  padding: 8px;
  color: #ffffff;
  transition: 0.3s;
  border: 1px solid #828282;
  display: inline-block;
  &:not(.chip.disabled) {
    &:hover {
      background: #ffffff;
      color: #828282;
      &.active {
        background: #ffffff;
        color: #26bc2c;
      }
    }
  }
  &.active {
    background: #26bc2c;
    border: 1px solid #26bc2c;
  }
}
.edit:deep() {
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 30px 30px rgba(39, 127, 175, 0.2);
  text-align: center;
  padding: 60px;
  position: relative;
  .close {
    padding: 16px;
  }

  h5 {
    text-align: center;
    margin-bottom: 50px;
  }
  form {
    text-align: left;
    display: grid;
    grid-column-gap: 30px;
    grid-row-gap: 10px;
    label {
      line-height: 26px;
      color: #52525f;
    }

    .v-text-field {
      padding-top: 0px;
      margin-top: 0px;
      fieldset {
        border: 1px solid #b4b4b4;
        border-radius: 4px;
      }
      .theme--light.v-icon {
        color: #b4b4b4;
      }
    }
    .container_btn {
      display: grid;
      justify-content: center;
      margin-top: 30px;
    }
    .v-input--selection-controls {
      margin-top: 0;
    }
  }
}
</style>
